import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { loadBackOfficeUser } from 'store/modules/backOfficeUser/actions';
import { UserId } from 'types/models/user';

interface Props {
  userId?: UserId;
}

function BackOfficeUserRequest({ userId }: Props): null {
  const dispatch = useDispatch();

  useEffect(() => {
    if (userId) {
      dispatch(loadBackOfficeUser(userId));
    }
  }, [userId, dispatch]);

  return null;
}

export default BackOfficeUserRequest;
